import React, { useState } from "react";
import { FaEnvelope, FaInstagram, FaBluesky, FaDumbbell, FaLinkedin } from "react-icons/fa6";

const SOCIAL_LINKS = [
  { id: "email", icon: FaEnvelope, label: "Email", url: "mailto:omega-avenge-smile@duck.com" },
  { id: "instagram", icon: FaInstagram, label: "Instagram", url: "https://www.instagram.com/div.yan.shu" },
  { id: "bluesky", icon: FaBluesky, label: "Bluesky", url: "https://bsky.app/profile/divyanshu.me" },
  { id: "hevy", icon: FaDumbbell, label: "Hevy", url: "https://hevy.com/user/divyanshupatel" },
  { id: "linkedin", icon: FaLinkedin, label: "LinkedIn", url: "https://www.linkedin.com/in/divvpatel/" },
];

function openWindow(url) {
  const link = document.createElement("a");
  if (url) {
    link.href = url;
    if (!url.startsWith("mailto:") && !url.startsWith("tel:")) {
      link.target = "_blank";
      link.rel = "noopener noreferrer";
    }
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}

function trackClick(link) {
  if (window.gtag) {
    const linkUrl = link.url.startsWith("mailto:")
      ? "mailto:"
      : link.url.startsWith("tel:")
      ? "tel:"
      : link.url;
    window.gtag("event", `link_click_${link.id}`, {
      platform: link.id,
      label: link.label,
      url: linkUrl,
    });
  }
}

function Avatar() {
  const [imgError, setImgError] = useState(false);

  if (imgError) {
    return (
      <div className="mx-auto mb-6 w-28 h-28 rounded-full bg-gradient-to-br from-red-500 to-blue-600 flex items-center justify-center text-3xl font-bold border-4 border-red-500 shadow-lg">
        DP
      </div>
    );
  }

  return (
    <div className="mx-auto mb-6 w-28 h-28 rounded-full overflow-hidden border-4 border-red-500 shadow-lg">
      <img
        src="/profile.jpg"
        alt="Divyanshu Patel"
        className="w-full h-full object-cover"
        onError={() => setImgError(true)}
      />
    </div>
  );
}

function AboutMe() {
  return (
    <main className="w-full max-w-md mx-auto px-6 py-12 text-center text-white">
      <Avatar />

      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-2">
        Divyanshu Patel
      </h1>
      <p className="text-sm sm:text-base font-medium text-white/90 mb-8">
        SWE • Georgia Tech Alum • DC
      </p>

      <nav className="flex items-center justify-center gap-4" aria-label="Social links">
        {SOCIAL_LINKS.map((link) => {
          const Icon = link.icon;
          return (
            <button
              key={link.id}
              onClick={() => {
                trackClick(link);
                openWindow(link.url);
              }}
              title={link.label}
              aria-label={link.label}
              className="p-1 text-white hover:opacity-80 hover:scale-110 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/30 rounded"
            >
              <Icon className="w-8 h-8 sm:w-9 sm:h-9" />
            </button>
          );
        })}
      </nav>

      <p className="mt-10 text-xs font-medium text-white/60">divyanshu.me</p>
    </main>
  );
}

export default AboutMe;
